import { useState, useEffect } from 'react';
import { getGDPRSettingsByID, CompanyGdprSettingsDTO } from 'wisestep-api';

const useGDPRSettings = (companyId: string): [CompanyGdprSettingsDTO | undefined] => {
  const [companyGdprSettingsDTO, setCompanyGdprSettingsDTO] = useState<CompanyGdprSettingsDTO>();
  useEffect(() => {
    const fetchCompanyGdprSettings = async () => {
      const settingsResponse = await getGDPRSettingsByID(companyId);
      const response = settingsResponse.data;
      if (response) setCompanyGdprSettingsDTO(response);
    };
    fetchCompanyGdprSettings();
  }, [companyId]);
  return [companyGdprSettingsDTO];
};

export default useGDPRSettings;
